import styled from 'styled-components';

export const StepContainer = styled.section`
    display: flex;
    flex-direction: column;
    max-width: 650px;
    padding: 20px;
    margin: 0 auto;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
`
export const TextInput = styled.input`
    width: 100%;
    padding: 10px 20px;
    font-family: "Lato";
    box-shadow: 0px 3px 6px #00000015;
    border: 1px solid #EFEFEF;
    border-radius: 2px;
    font-size: 17px;
		margin-bottom: 15px;
		-webkit-appearance: none;
	
`